// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1_21A","dragIcon":"Choice_dragIcon__3VYKO","left":"Choice_left__2sdgE","input":"Choice_input__2L07a"};